import * as React from "react";
import { TouchableOpacity, View, Text, StyleSheet } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import { currentLanguage } from "../../translations/CurrentLanguage";

import translation from "../.././translations/translation";
import LocalizedStrings from "react-native-localization";
import { colors } from "../../theme/modern";

let strings = new LocalizedStrings(translation);

class ShiftReportCardComponent extends React.PureComponent {
  onPress = () => this.props.onPress(this.props.shift);

  render() {
    strings.setLanguage(currentLanguage().companyLanguage);

    return (
      <TouchableOpacity
        activeOpacity={0.7}
        style={styles.row}
        onPress={this.onPress}
      >
        <View style={styles.icon}>
          <Icon name="clock" size={20} color={colors.primary} />
        </View>
        <View style={styles.main}>
          <Text style={styles.title}>
            {strings.Shift} #{this.props.shiftNumber}
          </Text>
          <Text style={styles.muted}>{this.props.attendant}</Text>
        </View>
        <Text style={styles.date}>{this.props.date.toLocaleDateString()}</Text>
        <Icon name="chevron-right" size={22} color={colors.textFaint} />
      </TouchableOpacity>
    );
  }
}

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 14,
    paddingLeft: 18,
    paddingRight: 12,
    borderBottomWidth: 1,
    borderBottomColor: "#eef2f7",
  },
  icon: {
    width: 42,
    height: 42,
    borderRadius: 12,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.primarySoft,
  },
  main: {
    flex: 1,
    marginLeft: 14,
  },
  title: {
    fontSize: 16,
    fontWeight: "700",
    color: colors.text,
  },
  muted: {
    marginTop: 3,
    fontSize: 13,
    color: colors.textMuted,
  },
  date: {
    marginRight: 8,
    fontSize: 14,
    fontWeight: "600",
    color: "#334155",
  },
});

export default ShiftReportCardComponent;
